<template>
    <div class="p-3">
        <button class="d-flex flex-row gx-4px border-0 bg-white" @click="handleGoBack">
            <img src="@/assets/icons/arrow-back.png" />
            <div class="arrow-button">INDIETRO</div>
        </button>

        <div class="d-flex flex-col w-100">
            <div class="d-flex flex-row w-100">
                <h1 class="text-title">Itinerari consigliati</h1>
                <div class="ml-auto d-flex flex-row gap-16px">
                    <ButtonComponent text="SALVA BOZZA" type="regular" class="bg-white" :isDisable="false"
                        @handleClick="handleDraft" />
                    <!-- <ButtonComponent text="PUBBLICA ITINERARIO" type="disabled" class="bg-disabled" :isDisable="true" /> -->
                </div>
            </div>
        </div>
        <div>
            <p class="text-overview">{{ published }} itinerari pubblicati su {{ totals }} presenti</p>
        </div>
        <div class="mt-48px d-flex flex-row gap-16px ">
            <div class="create-route-panel-body flex-1 ">
                <div class="d-flex flex-row gap-16px w-100">
                    <InputComponent :title="titleMap[langCode].title" :max-number="50"
                        :text="textVar[titleMap[langCode].index].value" :placeholder="titleMap[langCode].placeholder"
                        :language="langCode" @handleText="handleTitle" />
                    <InputComponent :title="subtitleMap[langCode].title" :max-number="50"
                        :text="textVar[subtitleMap[langCode].index].value"
                        :placeholder="subtitleMap[langCode].placeholder" :language="langCode"
                        @handleText="handleSubTitle" />
                </div>
                <div class="d-flex flex-row gap-16px w-100">
                    <TextAreaComponent :title="practicabilityMap[langCode].title" :max-number="500" :rows="4"
                        :placeholder="practicabilityMap[langCode].placeholder" :language="langCode"
                        :text="textVar[practicabilityMap[langCode].index].value" @handleText="handlePracticability" />
                    <TextAreaComponent :title="durationMap[langCode].title" :max-number="500" :rows="4"
                        :placeholder="durationMap[langCode].placeholder" :language="langCode"
                        :text="textVar[durationMap[langCode].index].value" @handleText="handleDuration" />
                </div>
                <div class="d-flex flex-row gap-16px w-100">
                    <div class="flex-1">
                        <TextAreaComponent :title="descriptionMap[langCode].title" :max-number="2000" :rows="8"
                            :placeholder="descriptionMap[langCode].placeholder" :language="langCode"
                            :text="textVar[descriptionMap[langCode].index].value" @handleText="handleDescription" />
                    </div>
                    <div class="flex-1">
                        <ImgUploadComponent :token="token" :baseUrl="props.baseUrl" @handleUpload="handleUpload" />
                    </div>
                </div>
                <div class="d-flex flex-row gap-16px w-100">
                    <div class="flex-1">
                        <CheckerComponent title="Ticketing" label="L'itinerario prevede l’acquisto di un biglietto"
                            @handleCheck="handleTicket" :isChecked="ticketRequired" />
                    </div>
                </div>
                <div class="w-50 gap-8px">
                    <div class="title-input">
                        Seleziona il raggruppamento inerente all'itinerario
                    </div>
                    <div v-if="isLoading">
                        <Loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" color="#2D489D"
                            loader="dots"></Loading>
                    </div>
                    <div v-else-if="getError">{{ getError }}</div>
                    <div v-else>
                        <Multiselect :searchable="false" :show-labels="false" :allow-empty="false" label="name"
                            v-model="groupField" :options="groupsetData" :hideSelected="true" track-by="name">
                        </Multiselect>
                    </div>
                </div>
                <div class="d-flex flex-row w-100">
                    <div class="w-50">
                        <SearchItemComponent @selectedMusuemFunc="selectedMusuemFunc" :museumData="museumsData"
                            :baseUrl="props.baseUrl" />
                    </div>
                    <div class="w-50 px-3">
                        <MuseumListComponent :selectedList="selectMuseums" @onMuseumOrderChange="onMuseumOrderChange" />
                    </div>
                </div>
            </div>
            <div class=" ">
                <LanguageComponent @handleLang="handleLang" @handleLabel="handleLabel" :token="token"
                    :languageJson="languageData" :baseUrl="props.baseUrl" :itineraryTypesData="itineraryTypesData" />
            </div>
        </div>
        <widget-container-modal />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ButtonComponent from '../components/Button.vue';
import InputComponent from '../components/Input.vue';
import TextAreaComponent from '../components/TextArea.vue';
// import ImageUploadComponent from '../components/ImageUpload.vue'
import ImgUploadComponent from '@/components/ImageUpload/ImgUploadComponent.vue';
import CheckerComponent from '../components/Checker.vue'
import SearchItemComponent from '../components/SearchItem.vue'
import LanguageComponent from '../components/Language.vue'
import MuseumListComponent from '../components/MuseumList.vue';
import ValidateModal from '../components/ValidateModal.vue';
import {
    container,
    openModal
} from "jenesius-vue-modal";
import {
    ref,
    onMounted,
    watch,
    onBeforeMount
} from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {
    useToast
} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';

export default {
    name: 'AddRouteView',
    components: {
        ButtonComponent,
        InputComponent,
        TextAreaComponent,
        ImgUploadComponent,
        CheckerComponent,
        SearchItemComponent,
        LanguageComponent,
        MuseumListComponent,
        Multiselect,
        Loading,
        WidgetContainerModal: container
    },
    props: {
        router: {
            type: Object
        },
        baseUrl: {
            type: String
        },
        languageJson: {
            type: Array
        },
    },
    setup(props) {
        const groupsetData = ref([]);
        const selectMuseums = ref([]);
        const museumsData = ref([]);
        const groupField = ref({
            name: ''
        });
        const isLoading = ref(false);
        const getError = ref(null);
        const ticketRequired = ref(false);
        const langCode = ref('it');
        const imagesData = ref([]);
        const validateText = ref([]);
        const itineraryTypesData = ref([]);
        const labelData = ref([]);
        const $toast = useToast();
        const token = ref('');
        // const baseUrl = 'https://ssot.laculturapremia.it/api';
        const totals = ref(0);
        const userRole = ref(true);
        const published = ref(0);
        const router = ref(props.router);
        const languageData = ref(props.languageJson.filter(val => !val.is_sign_language && !val.tours_only));

        const textVar = ref([]);
        const langIndexMap = {};
        const titleMap = {};
        const subtitleMap = {};
        const descriptionMap = {};
        const practicabilityMap = {};
        const durationMap = {};

        languageData.value.forEach((lang, index) => {
            const baseIndex = index * 5;

            textVar.value.push(
                { key: 'labels.title', value: '', languageCode: lang.lang_code },
                { key: 'labels.subtitle', value: '', languageCode: lang.lang_code },
                { key: 'labels.description', value: '', languageCode: lang.lang_code },
                { key: 'labels.practicability', value: '', languageCode: lang.lang_code },
                { key: 'labels.duration', value: '', languageCode: lang.lang_code }
            );

            langIndexMap[lang.lang_code] = {
                title: baseIndex,
                subtitle: baseIndex + 1,
                description: baseIndex + 2,
                practicability: baseIndex + 3,
                duration: baseIndex + 4
            };

            titleMap[lang.lang_code] = {
                title: 'Titolo',
                index: baseIndex,
                placeholder: 'Inserisci un titolo'
            };

            subtitleMap[lang.lang_code] = {
                title: 'Sottotitolo',
                index: baseIndex + 1,
                placeholder: 'Inserisci un sottotitolo'
            };

            descriptionMap[lang.lang_code] = {
                title: 'Descrizione',
                index: baseIndex + 2,
                placeholder: 'Inserisci una descrizione'
            };

            practicabilityMap[lang.lang_code] = {
                title: 'Praticabilità',
                index: baseIndex + 3,
                placeholder: 'Inserisci una praticabilità'
            };

            durationMap[lang.lang_code] = {
                title: 'Durata dell\'itinerario',
                index: baseIndex + 4,
                placeholder: 'Inserisci una durata'
            };
        });


        const fetchMuseums = async (groupset) => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(`${props.baseUrl}/v1.1/private/museums`, {
                        params: {
                            groupsetId: groupset.uuid
                        },
                        headers: {
                            Authorization: `Bearer ${token.value}`
                        }
                    });
                getError.value = null;
                museumsData.value = response.data.results.map(val => ({
                    ...val,
                    flag: false
                })).sort((a, b) => {
                    const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                    const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
            } catch (error) {
                getError.value = error;
                museumsData.value = null;
            } finally {
                isLoading.value = false;
            }
        };

        const fetchItinerariesTypes = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1/public/itinerary-types`);
                getError.value = null;
                itineraryTypesData.value = response.data;

            } catch (error) {
                getError.value = error;
                itineraryTypesData.value = null;
            } finally {
                isLoading.value = false;
            }
        }

        const fetchGroupset = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1.1/private/groupsets`, {
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                getError.value = null;
                groupsetData.value = response.data.results;
                groupField.value = response.data.results[0];
            } catch (error) {
                getError.value = error;
                groupsetData.value = null;
                groupField.value = null;
            } finally {
                isLoading.value = false;
            }
        };

        const fetchData = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .post(
                        `${props.baseUrl}/v1/private/itineraries/totals`, {}, {
                        headers: {
                            Authorization: `Bearer ${token.value}`,
                        },
                    }
                    );
                getError.value = null;
                switch (response.data.length) {
                    case 0:
                        totals.value = published.value = 0
                        break;
                    case 1:
                        totals.value = response.data[0].total;
                        response.data[0].status === "DRAFT" ? published.value = 0 : published.value = response.data[0].total
                        break;
                    default:
                        totals.value = response.data[0].total + response.data[1].total;
                        published.value = response.data.filter(val => val.status === 'PUBLISHED')[0].total;
                        break;
                }
            } catch (error) {
                getError.value = error;
                totals.value = published.value = null;
            } finally {
                isLoading.value = false;
            }
        };

        const selectedMusuemFunc = (selectedMuseums) => {
            selectMuseums.value = [...selectedMuseums.value].map(val => ({
                ...val
            }));
        }

        const handleTicket = (payload) => {
            ticketRequired.value = payload;
        }

        const handleTextUpdate = (payload, type) => {
            const index = langIndexMap[payload.lang][type];
            textVar.value[index] = {
                ...textVar.value[index],
                value: payload.text
            };
        };

        const handleTitle = (payload) => handleTextUpdate(payload, 'title');
        const handleSubTitle = (payload) => handleTextUpdate(payload, 'subtitle');
        const handleDescription = (payload) => handleTextUpdate(payload, 'description');
        const handlePracticability = (payload) => handleTextUpdate(payload, 'practicability');
        const handleDuration = (payload) => handleTextUpdate(payload, 'duration');

        const handleLang = (payload) => {
            langCode.value = languageData.value.find(val => val.name === payload).lang_code;
        }

        const handleUpload = (payload) => {
            imagesData.value = payload;
        }

        const onShowModal = () => {
            openModal(ValidateModal, {
                modalTitle: 'Avvertimento',
                modalContent: validateText.value
            })
        }

        const onMuseumOrderChange = (payload) => {
            selectMuseums.value = payload;
        }

        const handleLabel = (payload) => {
            labelData.value = payload;
        }

        const isEmpty = (str) => {
            return (str === null || str === undefined || str.length <= 0) ? true : false;
        }

        const handleDraft = () => {
            const requiredFields = languageData.value
                .filter(lang => lang.required)
                .flatMap(lang => [
                    { value: textVar.value[langIndexMap[lang.lang_code].title].value, label: `<b>Titolo in ${lang.name}</b>` },
                    { value: textVar.value[langIndexMap[lang.lang_code].description].value, label: `<b>Descrizione in ${lang.name}</b>` }
                ]);

            requiredFields.push(
                { value: imagesData.value, label: '<b>Immagini</b>' },
            );

            validateText.value = requiredFields
                .filter(field => isEmpty(field.value))
                .map(field => field.label);

            if (selectMuseums.value.length < 2) {
                validateText.value.push('<b>Musei</b>');
            }

            if (validateText.value.length > 0) {
                onShowModal();
                return false;
            }

            isLoading.value = true;
            axios.post(
                `${props.baseUrl}/v1/private/itineraries`, {
                status: 'DRAFT',
                markedPath: false,
                ticketRequired: ticketRequired.value,
                museums: selectMuseums.value.map(val => val.uuid),
                images: imagesData.value.map(val => val.uuid),
                name: textVar.value.find((text) => text.languageCode === "it" && text.key.includes("title"))?.value,
                groupsetId: groupField.value.uuid,
                textFields: textVar.value,
                types: labelData.value.map(val => val.uuid)
            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token.value}`,
                },
            }
            ).then(() => {
                $toast.success("L'itinerario è stato salvato con successo.", {
                    position: 'top-right'
                });

                router.value.push({
                    name: 'Itineraries'
                });
            }).catch((err) => {
                getError.value = err;
            }).finally(() => {
                isLoading.value = false;
            });

            return true;
        }

        const handleGoBack = () => {
            router.value.go(-1);
        }

        watch(groupField, newValue => {
            fetchMuseums(newValue)
            selectMuseums.value = [];
        })

        onBeforeMount(() => {
            const data = localStorage.getItem('mi_cms-tokens');
            if (data === null || data === undefined || data === '')
                return;
            else {
                token.value = JSON.parse(data).access;
            }
        })

        onMounted(() => {
            if (props.languageJson.length) {
                languageData.value = props.languageJson.filter(val => val.is_sign_language === false && val.tours_only === false);
            }
            fetchData();
            fetchGroupset();
            fetchItinerariesTypes();
        })

        return {
            props,
            languageData,
            isLoading,
            getError,
            selectMuseums,
            groupField,
            groupsetData,
            ticketRequired,
            langCode,
            published,
            totals,
            userRole,
            museumsData,
            textVar,
            validateText,
            itineraryTypesData,
            titleMap,
            subtitleMap,
            descriptionMap,
            practicabilityMap,
            durationMap,
            token,
            selectedMusuemFunc,
            handleTicket,
            handleLabel,
            handleDraft,
            handleTitle,
            handleSubTitle,
            handleDescription,
            handlePracticability,
            handleDuration,
            handleLang,
            handleUpload,
            onMuseumOrderChange,
            handleGoBack
        }
    }
}
</script>

<style>
.gx-4px {
    gap: 4px;
}

.arrow-button {
    color: var(--neutrali-grigio-scuro, #4C4C4C);
    /* caption */
    font-family: Titillium Web;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    /* 171.429% */
}

.create-route-panel-body {
    display: flex;
    padding: 16px;
    align-items: flex-start;
    align-content: flex-start;
    flex-shrink: 0;
    flex-wrap: wrap;
    gap: 32px;
    border-radius: 8px;
    border: 1px solid var(--neutrali-grigio-segnaposto, #8F8F8F);
}

p.text-overview {
    text-align: left;
}

.flex-1 {
    flex: 1;
}

img {
    display: block;
}

.label-left {
    padding-right: 0 !important;
}

.label-right {
    padding-left: 0 !important;
}
</style>
